import React, { forwardRef } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import linePattern from "images/patterns/page-pattern.svg";
import "./page-section.scss";

const PageSection = forwardRef(
  (
    {
      children,
      className,
      startIconClassName,
      endIconClassName,
      startScrollIcon = false,
      endScrollIcon = false,
      pattern = linePattern,
      startIconTo,
      endIconTo,
      style,
      ...props
    },
    ref
  ) => {
    return (
      <section
        ref={ref}
        style={{
          backgroundImage: pattern ? `url(${pattern})` : undefined,
          ...style,
        }}
        className={classNames(
          "relative bg-no-repeat flex items-center",
          className
        )}
        {...props}
      >
        {startScrollIcon && (
          <MouseIcon
            to={startIconTo}
            className={classNames(startIconClassName, "top-0")}
          />
        )}

        {children}

        {endScrollIcon && (
          <MouseIcon
            to={endIconTo}
            className={classNames(endIconClassName, "bottom-0")}
          />
        )}
      </section>
    );
  }
);

const MouseIcon = ({ className, to }) => {
  return (
    <div className={classNames("absolute center-absolute-x", className)}>
      <a className="mouse-down" href={`#${to}`} title="Scroll Down">
        <span />
      </a>
    </div>
  );
};

MouseIcon.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
};

PageSection.propTypes = {
  className: PropTypes.string,
  startIconClassName: PropTypes.string,
  endIconClassName: PropTypes.string,
  pattern: PropTypes.string,
  startScrollIcon: PropTypes.bool,
  endScrollIcon: PropTypes.bool,
  startIconTo: PropTypes.string,
  endIconTo: PropTypes.string,
};

export default PageSection;
